
import { GET_EMAIL_ID_VERIFY_START,
  GET_EMAIL_ID_VERIFY_SUCCESS, GET_EMAIL_ID_VERIFY_FAILURE, REGISTER_MEMBER_START,
  REGISTER_MEMBER_SUCCESS, REGISTER_MEMBER_FAILURE,
  GET_MEMBER_VERIFICATION_CODE_START, GET_MEMBER_VERIFICATION_CODE_SUCCESS, GET_MEMBER_VERIFICATION_CODE_FAILURE,
  RESET_ERROR_MESSAGE, MEMBER_LOGIN_REDIRECT_START, MEMBER_LOGIN_REDIRECT_SUCCESS, MEMBER_LOGIN_REDIRECT_FAILURE,
  MEMBER_AUTHENTICATION_START, MEMBER_AUTHENTICATION_SUCCESS, MEMBER_AUTHENTICATION_FAILURE,
  GET_USER_ID_FAILURE, GET_USER_ID_SUCCESS, GET_USER_ID_START,
  RESET_PASSWORD_START, RESET_PASSWORD_FAILURE, RESET_PASSWORD_SUCCESS,
  GET_MEMBER_DETAILS_FAILURE, GET_MEMBER_DETAILS_START, GET_MEMBER_DETAILS_SUCCESS,
  MEMBER_VALIDATION_FAILURE, MEMBER_VALIDATION_START, MEMBER_VALIDATION_SUCCESS,
  VERIFY_TOKEN_START, VERIFY_TOKEN_SUCCESS, VERIFY_TOKEN_FAILURE,
  EMAIL_VERIFICATION_START, EMAIL_VERIFICATION_SUCCESS, EMAIL_VERIFICATION_FAILURE, RESET_REDIRECT_URL,
  GET_EMAIL_VERIFICATION_CODE_START, GET_EMAIL_VERIFICATION_CODE_SUCCESS, GET_EMAIL_VERIFICATION_CODE_FAILURE
} from '../actions/types';

const initialState = {
  members: [],
  member: undefined,
  errorMessage: '',
  loading: false,
  memberRegistered: '',
  forgetErrMsg: undefined,
  url: undefined,
  hasCaseHead: false,
  verificationCode: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_EMAIL_ID_VERIFY_START:
      return { ...state };
    case GET_EMAIL_ID_VERIFY_SUCCESS:
      return { ...state, emailVerify: action.payload };
    case GET_EMAIL_ID_VERIFY_FAILURE:
      return { ...state };
    case REGISTER_MEMBER_START:
      return { ...state, loading: true, errorMessage: '', verificationCode: '' };
    case REGISTER_MEMBER_SUCCESS:
      return { ...state, memberRegistered: action.payload, userParams: action.userParams, loading: false};
    case REGISTER_MEMBER_FAILURE:
      return { ...state, errorMessage: action.errorMessage && action.errorMessage.message, loading: false };
    case GET_MEMBER_VERIFICATION_CODE_START:
      return { ...state, loading: true };
    case GET_MEMBER_VERIFICATION_CODE_SUCCESS:
      // console.log(`UserInfo: ${JSON.stringify(action.userInfo)}`);
      // console.log(`Verification Code: ${JSON.stringify(action.payload.activationCode)}`);
      return { ...state, verificationCode: action.payload.activationCode, loading: false, userInfo: action.userInfo  };
    case GET_MEMBER_VERIFICATION_CODE_FAILURE:
      return { ...state, loading: false };
    case RESET_ERROR_MESSAGE:
      return { ...state, errorMessage: '', forgetErrMsg: undefined };
    case MEMBER_LOGIN_REDIRECT_START:
      return { ...state, loading: true };
    case MEMBER_LOGIN_REDIRECT_SUCCESS:
      // console.log(`requestId: ${JSON.stringify(action.payload.requestId)}`);
      return { ...state, requestId: action.payload.requestId, loading: false };
    case MEMBER_LOGIN_REDIRECT_FAILURE:
      return { ...state, loading: false };
    case MEMBER_AUTHENTICATION_START:
      return { ...state, loading: true, memberData: undefined, loginErrorMsg: undefined, url: undefined };
    case MEMBER_AUTHENTICATION_SUCCESS:
      const url = action.payload && action.payload.response.url;
      return { ...state, memberData: action.payload, loading: false , url: url};
    case MEMBER_AUTHENTICATION_FAILURE:
      return { ...state, loginErrorMsg: action.loginErrorMsg, loading: false, url: undefined };
    case RESET_REDIRECT_URL:
      return { ...state, url: undefined };
    case GET_USER_ID_START:
      return { ...state, loading: true, forgetErrMsg: undefined };
    case GET_USER_ID_SUCCESS:
      return { ...state, loading: false, userInfo: action.userInfo };
    case GET_USER_ID_FAILURE:
      return { ...state, loading: false, forgetErrMsg: action.errorMessage };
    case RESET_PASSWORD_START:
      return { ...state, loading: true };
    case RESET_PASSWORD_SUCCESS:
      return { ...state, loading: false };
    case RESET_PASSWORD_FAILURE:
      return { ...state, loading: false };
    case GET_MEMBER_DETAILS_START:
      return { ...state, loading: true, memberDetails: undefined };
    case GET_MEMBER_DETAILS_SUCCESS:
      return { ...state, memberDetails: action.payload, loading: false };
    case GET_MEMBER_DETAILS_FAILURE:
      return { ...state, loading: false };
    case MEMBER_VALIDATION_START:
      return { ...state, loading: true, hasCaseHead: false };
    case MEMBER_VALIDATION_SUCCESS:
      // console.log(`action.payload: ${JSON.stringify(action.payload)}`)
      return { ...state, loading: false, hasCaseHead: action.payload.hasCaseHead, email: action.payload.email };
    case MEMBER_VALIDATION_FAILURE:
      return { ...state, errorMessage: action.errorMessage, loading: false };
    case VERIFY_TOKEN_START:
      return { ...state, loading: true, errorMessage: "" };
    case VERIFY_TOKEN_SUCCESS:
      return { ...state, loading: false};
    case VERIFY_TOKEN_FAILURE:
      return { ...state, errorMessage: action.errorMessage, loading: false };
    case EMAIL_VERIFICATION_START:
      return { ...state, loading: true, errorMessage: "" };
    case EMAIL_VERIFICATION_SUCCESS:
      return { ...state, loading: false};
    case EMAIL_VERIFICATION_FAILURE:
      return { ...state, errorMessage: action.errorMessage, loading: false };
    case GET_EMAIL_VERIFICATION_CODE_START:
      return { ...state, loading: true, errorMessage: "" };
    case GET_EMAIL_VERIFICATION_CODE_SUCCESS:
      return { ...state, loading: false};
    case GET_EMAIL_VERIFICATION_CODE_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};
